import { spawn } from 'redux-saga/effects';

import agreementSagas from './agreement/agreementSagas';

export default function* sagas() {
	yield spawn(agreementSagas);
}
